module.exports = __webpack_public_path__ + "static/media/file-video.ab3f6eb3.svg";